// extracted by mini-css-extract-plugin
export var activeBar = "TabbedCustomerStories-module--active-bar--7b142";
export var activeLine = "TabbedCustomerStories-module--active-line--15cac";
export var bigStat = "TabbedCustomerStories-module--big-stat--2c724";
export var container = "TabbedCustomerStories-module--container--d1289";
export var desktopStats = "TabbedCustomerStories-module--desktop-stats--ec8aa";
export var lilacLight = "TabbedCustomerStories-module--lilac-light--eabbb";
export var logo = "TabbedCustomerStories-module--logo--86978";
export var mobileStats = "TabbedCustomerStories-module--mobile-stats--d9b47";
export var progressBar = "TabbedCustomerStories-module--progress-bar--33c65";
export var section = "TabbedCustomerStories-module--section--05239";
export var stat = "TabbedCustomerStories-module--stat--89876";
export var stories = "TabbedCustomerStories-module--stories--e180a";
export var story = "TabbedCustomerStories-module--story--687e3";
export var tabs = "TabbedCustomerStories-module--tabs--d8903";
export var videoPlayer = "TabbedCustomerStories-module--video-player--3e3d0";
export var visual = "TabbedCustomerStories-module--visual--886d0";